<div class="w-full">

  <!-- Nagłówek + statystyki magazynu logów (przewija się) -->
  <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">REST API</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">Konta API, webhooki, logi i naruszenia limitów</p>
    </div>
    <div *ngIf="stats" class="text-xs text-gray-500 dark:text-gray-400 flex flex-wrap gap-x-4 gap-y-1">
      <span>Magazyn logów: <b class="text-gray-700 dark:text-gray-200">{{ stats.sink }}</b></span>
      <span *ngIf="stats.count != null">Wpisów: <b class="text-gray-700 dark:text-gray-200">{{ stats.count | number }}</b></span>
      <span *ngIf="stats.sizeMb != null">Rozmiar: <b class="text-gray-700 dark:text-gray-200">{{ stats.sizeMb }} MB</b></span>
      <span *ngIf="stats.retentionDays != null">Retencja: <b class="text-gray-700 dark:text-gray-200">{{ stats.retentionDays }} dni</b></span>
    </div>
  </div>

  <!-- PRZYKLEJONY pasek: zakładki + filtry (zawsze widoczne przy scrollu) -->
  <div class="sticky top-0 z-20 bg-gray-50 dark:bg-gray-900 -mx-4 sm:-mx-6 px-4 sm:px-6 pt-1 pb-3 mb-5 border-b border-gray-200 dark:border-gray-700">
    <!-- Zakładki -->
    <div class="flex flex-wrap gap-2">
      <button (click)="setTab('accounts')"
        [ngClass]="tab === 'accounts' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'"
        class="px-4 py-2 border-b-2 font-medium text-sm">Konta API</button>
      <button (click)="setTab('webhooks')"
        [ngClass]="tab === 'webhooks' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'"
        class="px-4 py-2 border-b-2 font-medium text-sm">Webhooki</button>
      <button (click)="setTab('logs')"
        [ngClass]="tab === 'logs' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'"
        class="px-4 py-2 border-b-2 font-medium text-sm">Logi</button>
      <button (click)="setTab('offenders')"
        [ngClass]="tab === 'offenders' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'"
        class="px-4 py-2 border-b-2 font-medium text-sm">Naruszenia</button>
    </div>

    <!-- Filtry: Konta -->
    <div *ngIf="tab === 'accounts'" class="mt-3">
      <input [formControl]="accountsSearch" placeholder="Szukaj po nazwie, clientId, scope lub mailu klienta…"
        class="w-full sm:w-96 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm" />
    </div>

    <!-- Filtry: Webhooki -->
    <div *ngIf="tab === 'webhooks'" class="mt-3">
      <input [formControl]="webhooksSearch" placeholder="Szukaj po endpoint, opisie lub evencie…"
        class="w-full sm:w-96 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm" />
    </div>

    <!-- Filtry: Logi -->
    <div *ngIf="tab === 'logs'" class="mt-3 flex flex-wrap items-center gap-2">
      <input [formControl]="logsSearch" placeholder="Szukaj po endpoint…"
        class="w-full sm:w-64 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm" />
      <input [formControl]="logsAccountEmail" placeholder="Filtruj po mailu klienta…"
        class="w-full sm:w-56 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm" />
      <div class="flex gap-1">
        <button *ngFor="let t of [{k:'API',l:'API'},{k:'WEBHOOK',l:'Webhook'}]" (click)="setLogsType(t.k)"
          [ngClass]="logsType === t.k ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'"
          class="px-3 py-1.5 rounded-lg text-xs font-medium">{{ t.l }}</button>
      </div>
      <div class="flex gap-1">
        <button *ngFor="let c of ['2xx','4xx','5xx']" (click)="setLogsStatusClass(c)"
          [ngClass]="logsStatusClass === c ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'"
          class="px-3 py-1.5 rounded-lg text-xs font-medium">{{ c }}</button>
      </div>
      <div class="flex gap-1">
        <button *ngFor="let m of ['GET','POST','PUT','PATCH','DELETE']" (click)="setLogsMethod(m)"
          [ngClass]="logsMethod === m ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'"
          class="px-2.5 py-1.5 rounded-lg text-xs font-mono">{{ m }}</button>
      </div>
    </div>
  </div>

  <!-- ====================== KONTA API ====================== -->
  <section *ngIf="tab === 'accounts'">
    <div *ngIf="accountsLoading" class="flex justify-center py-10"><mat-spinner [diameter]="32"></mat-spinner></div>

    <div *ngIf="!accountsLoading" class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800 text-gray-500 dark:text-gray-400 text-left">
          <tr>
            <th class="px-3 py-2 font-medium">#</th>
            <th class="px-3 py-2 font-medium">Nazwa</th>
            <th class="px-3 py-2 font-medium">clientId</th>
            <th class="px-3 py-2 font-medium">Właściciel</th>
            <th class="px-3 py-2 font-medium">Scopy</th>
            <th class="px-3 py-2 font-medium">Status</th>
            <th class="px-3 py-2 font-medium">Ostatnie użycie</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
          <tr *ngFor="let a of accounts; let i = index" class="text-gray-700 dark:text-gray-200">
            <td class="px-3 py-2 text-gray-400">{{ rowNumber(accountsPg.currentPage, accountsPg.itemsPerPage, i) }}</td>
            <td class="px-3 py-2 font-medium">{{ a.name }}</td>
            <td class="px-3 py-2 font-mono text-xs">{{ a.clientId }}</td>
            <td class="px-3 py-2">{{ ownerLabel(a.userId) }}</td>
            <td class="px-3 py-2">
              <div class="flex flex-wrap gap-1 max-w-md">
                <span *ngFor="let s of a.scopes" class="px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 text-xs font-mono">{{ s }}</span>
                <span *ngIf="!a.scopes?.length" class="text-gray-400">-</span>
              </div>
            </td>
            <td class="px-3 py-2"><span class="px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300">{{ a.status }}</span></td>
            <td class="px-3 py-2 text-gray-500">{{ a.lastUseAt ? fmtDate(a.lastUseAt) : 'nigdy' }}</td>
          </tr>
          <tr *ngIf="!accounts.length"><td colspan="7" class="px-3 py-8 text-center text-gray-400">Brak kont API</td></tr>
        </tbody>
      </table>
    </div>

    <div class="mt-4" *ngIf="accountsPg.pages > 1">
      <pagination [currentPage]="accountsPg.currentPage" [totalPages]="accountsPg.pages" (onPageChange)="onAccountsPage($event)"></pagination>
    </div>
  </section>

  <!-- ====================== WEBHOOKI ====================== -->
  <section *ngIf="tab === 'webhooks'">
    <div *ngIf="webhooksLoading" class="flex justify-center py-10"><mat-spinner [diameter]="32"></mat-spinner></div>

    <div *ngIf="!webhooksLoading" class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800 text-gray-500 dark:text-gray-400 text-left">
          <tr>
            <th class="px-3 py-2 font-medium">#</th>
            <th class="px-3 py-2 font-medium">Endpoint</th>
            <th class="px-3 py-2 font-medium">Właściciel</th>
            <th class="px-3 py-2 font-medium">Eventy</th>
            <th class="px-3 py-2 font-medium">Status</th>
            <th class="px-3 py-2 font-medium">Sukces / Błąd</th>
            <th class="px-3 py-2 font-medium">Pod rząd</th>
            <th class="px-3 py-2 font-medium">Ostatnia dostawa</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
          <tr *ngFor="let w of webhooks; let i = index" class="text-gray-700 dark:text-gray-200">
            <td class="px-3 py-2 text-gray-400">{{ rowNumber(webhooksPg.currentPage, webhooksPg.itemsPerPage, i) }}</td>
            <td class="px-3 py-2 font-mono text-xs max-w-xs truncate" [title]="w.endpoint">{{ w.endpoint }}</td>
            <td class="px-3 py-2">{{ ownerLabel(w.userId) }}</td>
            <td class="px-3 py-2">
              <div class="flex flex-wrap gap-1 max-w-xs">
                <span *ngFor="let e of w.events" class="px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 text-xs font-mono">{{ e }}</span>
              </div>
            </td>
            <td class="px-3 py-2"><span class="px-2 py-0.5 rounded text-xs font-medium" [ngClass]="webhookStatusColor(w.status)">{{ w.status }}</span></td>
            <td class="px-3 py-2"><span class="text-green-600 dark:text-green-400">{{ w.successCount || 0 }}</span> / <span class="text-red-600 dark:text-red-400">{{ w.failureCount || 0 }}</span></td>
            <td class="px-3 py-2" [ngClass]="(w.consecutiveFailures || 0) > 0 ? 'text-red-600 dark:text-red-400 font-semibold' : 'text-gray-400'">{{ w.consecutiveFailures || 0 }}</td>
            <td class="px-3 py-2 text-gray-500">{{ w.lastDeliveryAt ? fmtDate(w.lastDeliveryAt) : '-' }}</td>
          </tr>
          <tr *ngIf="!webhooks.length"><td colspan="8" class="px-3 py-8 text-center text-gray-400">Brak webhooków</td></tr>
        </tbody>
      </table>
    </div>

    <div class="mt-4" *ngIf="webhooksPg.pages > 1">
      <pagination [currentPage]="webhooksPg.currentPage" [totalPages]="webhooksPg.pages" (onPageChange)="onWebhooksPage($event)"></pagination>
    </div>
  </section>

  <!-- ====================== LOGI (master-detail) ====================== -->
  <section *ngIf="tab === 'logs'">
    <div *ngIf="logsLoading" class="flex justify-center py-10"><mat-spinner [diameter]="32"></mat-spinner></div>

    <div *ngIf="!logsLoading" class="flex flex-col lg:flex-row gap-4 items-start">

      <!-- Lista żądań (karty) -->
      <div class="w-full lg:flex-1 lg:min-w-0">
        <div class="space-y-2">
          <div *ngFor="let l of logs" (click)="selectLog(l)"
            class="p-3 border rounded-lg cursor-pointer transition hover:bg-gray-50 dark:hover:bg-gray-800"
            [ngClass]="selectedLog === l ? 'border-blue-400 dark:border-blue-500 bg-blue-50 dark:bg-blue-900/20' : 'border-gray-200 dark:border-gray-700'">
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2 min-w-0">
                <span class="px-2 py-0.5 rounded text-xs font-medium shrink-0" [ngClass]="statusColor(l.status)">{{ l.status }}</span>
                <span class="text-sm font-semibold shrink-0">{{ l.method }}</span>
                <span class="text-sm text-gray-700 dark:text-gray-200 truncate" [title]="l.endpoint">{{ l.endpoint }}</span>
              </div>
              <span class="text-xs text-gray-400 whitespace-nowrap shrink-0">{{ fmtDate(l.ts) }}</span>
            </div>
            <div class="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500 dark:text-gray-400">
              <span [ngClass]="l.type === 'WEBHOOK' ? 'text-indigo-600 dark:text-indigo-400 font-medium' : ''">{{ l.type || 'API' }}</span>
              <span *ngIf="l.account">&bull;</span>
              <span *ngIf="l.account" class="font-mono truncate max-w-[160px]">{{ l.account }}</span>
              <span *ngIf="l.ip">&bull;</span>
              <span *ngIf="l.ip">IP: {{ l.ip }}</span>
              <span>&bull;</span>
              <span>{{ l.execMs }}ms</span>
            </div>
          </div>

          <div *ngIf="!logs.length" class="px-3 py-10 text-center text-gray-400 border border-dashed border-gray-200 dark:border-gray-700 rounded-lg">Brak logów</div>
        </div>

        <div class="mt-4" *ngIf="logsPg.pages > 1">
          <pagination [currentPage]="logsPg.currentPage" [totalPages]="logsPg.pages" (onPageChange)="onLogsPage($event)"></pagination>
        </div>
      </div>

      <!-- Szczegóły żądania (przyklejony panel po prawej) -->
      <div id="log-detail" class="w-full lg:w-[440px] lg:shrink-0" *ngIf="selectedLog">
        <div class="lg:sticky lg:top-[120px] rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 overflow-hidden">
          <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 dark:border-gray-700">
            <div class="text-base font-medium text-gray-800 dark:text-gray-100">Szczegóły żądania</div>
            <button (click)="selectedLog = null" class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-sm">Zamknij ✕</button>
          </div>

          <div class="p-5 space-y-5 lg:max-h-[calc(100vh-200px)] lg:overflow-y-auto">
            <div class="grid grid-cols-2 gap-4 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-xl text-sm border border-gray-100 dark:border-gray-700">
              <div><div class="text-gray-400 mb-1">Metoda</div><div class="font-medium">{{ selectedLog.method }}</div></div>
              <div><div class="text-gray-400 mb-1">Status</div><div><span class="px-2 py-0.5 rounded text-xs font-medium" [ngClass]="statusColor(selectedLog.status)">{{ selectedLog.status }}</span></div></div>
              <div><div class="text-gray-400 mb-1">IP</div><div class="font-medium">{{ selectedLog.ip || 'Brak' }}</div></div>
              <div><div class="text-gray-400 mb-1">Czas wykonania</div><div class="font-medium">{{ selectedLog.execMs }}ms</div></div>
              <div><div class="text-gray-400 mb-1">Typ</div><div class="font-medium">{{ selectedLog.type || 'API' }}</div></div>
              <div><div class="text-gray-400 mb-1">Konto</div><div class="font-medium font-mono text-xs break-all">{{ selectedLog.account || '-' }}</div></div>
              <div class="col-span-2"><div class="text-gray-400 mb-1">Czas</div><div class="font-medium">{{ fmtDate(selectedLog.ts) }}</div></div>
              <div class="col-span-2" *ngIf="selectedLog.ruid"><div class="text-gray-400 mb-1">RUID</div><div class="font-mono text-xs break-all">{{ selectedLog.ruid }}</div></div>
              <div class="col-span-2 break-all"><div class="text-gray-400 mb-1">Endpoint</div><div class="font-mono text-xs">{{ selectedLog.endpoint }}</div></div>
            </div>

            <div *ngIf="selectedLog.reqBody">
              <div class="text-sm font-medium mb-2 border-b border-gray-100 dark:border-gray-700 pb-1 text-gray-700 dark:text-gray-200">Request Body <span *ngIf="selectedLog.reqTruncated" class="text-xs text-amber-600">(ucięte)</span></div>
              <pre class="bg-gray-900 text-gray-100 p-4 rounded-lg text-xs overflow-x-auto whitespace-pre-wrap break-all">{{ selectedLog.reqBody }}</pre>
            </div>

            <div *ngIf="selectedLog.resBody">
              <div class="text-sm font-medium mb-2 border-b border-gray-100 dark:border-gray-700 pb-1 text-gray-700 dark:text-gray-200">Response Body <span *ngIf="selectedLog.resTruncated" class="text-xs text-amber-600">(ucięte)</span></div>
              <pre class="bg-gray-900 text-gray-100 p-4 rounded-lg text-xs overflow-x-auto whitespace-pre-wrap break-all">{{ selectedLog.resBody }}</pre>
            </div>

            <div *ngIf="!selectedLog.reqBody && !selectedLog.resBody" class="text-sm text-gray-400">Brak zapisanego body dla tego żądania.</div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- ====================== NARUSZENIA ====================== -->
  <section *ngIf="tab === 'offenders'">
    <div class="flex items-center justify-between mb-4">
      <p class="text-sm text-gray-500 dark:text-gray-400">Klienci objęci cooldownem za ignorowanie limitów (per IP / endpoint).</p>
      <button (click)="loadOffenders()" class="px-3 py-1.5 rounded-lg text-sm bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">Odśwież</button>
    </div>

    <div *ngIf="offendersLoading" class="flex justify-center py-10"><mat-spinner [diameter]="32"></mat-spinner></div>

    <div *ngIf="!offendersLoading && !offendersAvailable" class="p-6 rounded-lg border border-amber-200 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-800 text-amber-700 dark:text-amber-300 text-sm">
      Redis jest niedostępny — naruszenia/cooldowny nie są śledzone w tym środowisku.
    </div>

    <div *ngIf="!offendersLoading && offendersAvailable" class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <!-- Aktywne blokady -->
      <div class="rounded-lg border border-gray-200 dark:border-gray-700">
        <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-700 font-medium text-gray-700 dark:text-gray-200">Aktywne blokady ({{ activeCooldowns.length }})</div>
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
          <div *ngFor="let a of activeCooldowns" class="px-4 py-2.5 flex items-center justify-between text-sm">
            <span class="font-mono text-xs text-gray-700 dark:text-gray-200 truncate" [title]="a.key">{{ a.key }}</span>
            <span class="px-2 py-0.5 rounded bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 text-xs whitespace-nowrap">jeszcze {{ a.cooldownSeconds }} s</span>
          </div>
          <div *ngIf="!activeCooldowns.length" class="px-4 py-8 text-center text-gray-400 text-sm">Brak aktywnych blokad</div>
        </div>
      </div>

      <!-- Najczęściej blokowani -->
      <div class="rounded-lg border border-gray-200 dark:border-gray-700">
        <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-700 font-medium text-gray-700 dark:text-gray-200">Najczęściej blokowani</div>
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
          <div *ngFor="let o of offenders" class="px-4 py-2.5 flex items-center justify-between text-sm">
            <span class="font-mono text-xs text-gray-700 dark:text-gray-200 truncate" [title]="o.identifier">{{ o.identifier }}</span>
            <span class="px-2 py-0.5 rounded bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 text-xs whitespace-nowrap">{{ o.cooldowns }}× cooldown</span>
          </div>
          <div *ngIf="!offenders.length" class="px-4 py-8 text-center text-gray-400 text-sm">Brak naruszeń</div>
        </div>
      </div>
    </div>
  </section>

</div>
